/**
 * Vue-Routerルートガードの中でコールしたAPIのエラーハンドラー
 * @param {Function} next Vue-Routerのルートガード内のnext関数
 * @param {Error} error
 * @return {void}
 */
export const onError = (next, error) => {
  if (requiresLogin(error)) {
    next({ name: 'login', query: { next: location.pathname } })
  } else {
    next(error)
  }
}

/**
  * ログインが必要かどうかを判断します
  * @param {Error} error
  * @return {Boolean}
  */
export const requiresLogin = err => err.response?.body?.errorTitle === 'Unauthorized'
